<template>
  <div class="relative min-h-screen">
    <div class="flex justify-center" v-if="rating.isFirst">
      <bar-loader
        class="my-8"
        color="#4db1fa"
        :width="320"
      />
    </div>

    <div class="w-full max-w-lg mx-auto pt-6 px-8 md:px-0" v-else>
      <section class="flex justify-center">
        <img :src="`/images/avatars/${officer.emoji}.png`" class="h-16">
        <div class="ml-4">
          <p class="text-sm">Officer {{ officer.number }}</p>
          <p class="text-xs">{{ officer.location }}</p>
          <base-rating :value="officer.rating" readonly />
        </div>
      </section>

      <carousel
        class="my-12"
        :per-page="4"
        :paginationEnabled="false"
        @page-change="nextMediaPage"
        v-if="media.medias.length"
      >
        <slide
          v-for="(media, index) in media.medias"
          :key="media.id"
          :data-index="index"
          @slide-click="openMedia"
        >
          <img
            class="cursor-pointer w-full h-32 px-1 object-cover"
            :src="media.thumbnail"
          >
        </slide>
      </carousel>

      <modal
        name="media-preview"
        height="auto"
        draggable
        reset
      >
        <img
          v-if="media.selectedMedia.type === 'image'"
          class="w-full object-cover"
          :src="media.selectedMedia.url"
        >
        <video
          v-else
          :src="media.selectedMedia.url"
          class="w-full"
          autoplay
          controls
        />
      </modal>

      <section class="w-full mt-8 pb-40">
        <div
          v-for="rating in rating.ratings"
          :key="rating.id"
          class="w-full mt-4 mb-8"
        >
          <p class="text-sm">{{ rating.review }}</p>
          <div class="flex justify-between mt-2">
            <button
              class="btn-small h-6"
              :disabled="rating.is_owner"
              v-if="isAuthenticated"
              @click="reportRating(officer, rating)"
            >
              Flag this review
            </button>
            <p class="text-right">{{ rating.user }}</p>
          </div>
        </div>
      </section>
    </div>

    <base-footer class="absolute bottom-0" />
  </div>
</template>

<script>
import OfficerService from '@/services/OfficerService';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      officer: {},
      rating: {
        ratings: [],
        meta: {
          current_page: null,
        },
        isFirst: true,
      },
      media: {
        medias: [],
        selectedMedia: {},
        meta: {
          current_page: null,
        },
      },
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
  },
  watch: {
    async 'rating.meta.current_page'() {
      await this.fetch();
    },
    async 'media.meta.current_page'() {
      await this.fetchMedia();
    },
  },
  methods: {
    async fetch() {
      const { data: { data, meta } } = await OfficerService.getRatings(this.officer, {
        params: {
          page: this.rating.meta.currentPage,
        },
      });

      this.rating.ratings = this.rating.ratings.concat(data);
      this.rating.meta = meta;

      if (this.rating.isFirst) {
        this.rating.isFirst = false;
      }
    },

    async fetchMedia() {
      const { data: { data, meta } } = await OfficerService.getMedia(this.officer, {
        params: {
          page: this.media.meta.current_page,
        },
      });

      this.media.medias = this.media.medias.concat(data);
      this.media.meta = meta;
    },

    nextPage() {
      if (this.rating.meta.currentPage === this.rating.meta.last_page) {
        return;
      }
      this.rating.meta.current_page++;
    },

    nextMediaPage(carouselPage) {
      if (
        this.media.meta.current_page === this.media.meta.last_page ||
        (carouselPage + 1) % Math.round(this.media.meta.per_page / 6) !== 0
      ) {
        return;
      }
      this.media.meta.current_page++;
    },

    openMedia(dataset) {
      this.media.selectedMedia = this.media.medias[dataset.index];
      this.$modal.show('media-preview');
    },

    async reportRating(post, rating) {
      try {
        await OfficerService.reportRating(post, rating);
        this.$toasted.show('Review flagged successfully.');
      } catch (e) {
        // Ignore
      }
    },
  },
  async created() {
    try {
      const { data: { data } } = await OfficerService.showFromNumber(this.$route.params.id);

      this.officer = data;

      // Initialize pagination
      this.rating.meta.current_page = 1;
      this.media.meta.current_page = 1;

      this.$parent.$on('scroll_ended', this.nextPage);
    } catch(e) {
      this.$router.push({ name: 'cops' });
    }
  },
};
</script>

<style scoped>
video {
  max-height: 500px;
}
</style>
